import ArrowIcon from '@assets/images/icons/tooltip-arrow.svg?react'
import {
  Times as CloseIcon,
  RepeatSolid,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import { DescriptionPro, DescriptionTeam, Loader } from './components'
import css from './styles.module.css'
import { useAnnualPlanCallout } from './useAnnualPlanCallout'

interface Props {
  members: number
}

export const AnnualPlanCallout: React.FC<Props> = ({ members }) => {
  const { proPlan, teamPlan, hasMessage, loading, onCloseClick, onClick } =
    useAnnualPlanCallout()

  if (!hasMessage) {
    return null
  }

  const cn = clsJoin(
    css.to_annual_tooltip,
    proPlan && css.pro,
    teamPlan && css.team
  )

  return (
    <div className={cn}>
      <div className={css.header}>
        {proPlan && <DescriptionPro />}
        {teamPlan && <DescriptionTeam members={members} />}
        <button className={css.close_btn} onClick={onCloseClick}>
          <CloseIcon className={css.close_icon} />
        </button>
      </div>
      <button className={css.button} onClick={onClick}>
        {loading ? <Loader /> : <RepeatSolid className={css.btn_icon} />}
        Go annual
      </button>

      <ArrowIcon className={clsJoin(css.arrow)} />
    </div>
  )
}
